export function displayDate(value:string){const match=/^(\d{4})-(\d{2})-(\d{2})$/.exec(value);return match?`${match[3]}/${match[2]}/${match[1]}`:'Not confirmed';}
export function hireSummary(start:string,finish:string,weekly:number){
 const days=Math.round((Date.parse(finish+'T00:00:00Z')-Date.parse(start+'T00:00:00Z'))/86400000);
 if(!Number.isFinite(days)||days<=0||!Number.isFinite(weekly)||weekly<0)return {duration:'Not confirmed',total:null};
 const words=['Zero','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten'];
 const duration=days%7===0?`${words[days/7]||days/7} ${days===7?'week':'weeks'}`:`${days} days`;
 return {duration,total:Math.ceil(days/7)*weekly};
}
